import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";


export default class RecentlyBooked extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	componentDidMount(){
		//so the window pops up
		localStorage.setItem('ticketToggled', 'no');
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
			columns = [
				{
					sortable: false,
					Header: "Created",
					id: "created",
					/** @param {Tickets_Object} obj */
					accessor: obj => (moment(obj.created).format('MM-DD-Y hh:mm a'))
				},
				{
					sortable: false,
					Header: "Dispatcher",
					id: "creator",
					/** @param {Tickets_Object} obj */
					accessor: obj => (obj.users ? (obj.users.name_first + " " + obj.users.name_last) : "Admin")
				},
				{
					sortable: false,
					Header: "Field Engineer",
					id: "fe_name",
					/** @param {Tickets_Object} obj */
					accessor: obj => (obj.field_engineers.name_first + " " + obj.field_engineers.name_last)
				},
				{
					sortable: false,
					Header: "Booked Day",
					id: "appointment_start",
					/** @param {Tickets_Object} obj */
					accessor: obj => (moment(obj.appointment_start).format('MM/DD')),
					Cell: props => {
						return (
							<span>
								<Link to={`/dispatch/calendar/${props.original.pkey}`}>
									{(moment(props.original.appointment_start).format('MM/DD'))}
								</Link>
							</span>
						);
					}
				},
				{
					sortable: false,
					Header: "Booked Time",
					id: "booked_time",
					/** @param {Tickets_Object} obj */
					accessor: obj => (moment(obj.appointment_start).format('hh:mm a') + "-" + moment(obj.appointment_end).format('hh:mm a')),
					Cell: props => {
						return (
							<span>
								<Link to={`/dispatch/calendar/${props.original.pkey}`}>
									{(moment(props.original.appointment_start).format('hh:mm a') + "-" + moment(props.original.appointment_end).format('hh:mm a'))}
								</Link>
							</span>
						);
					}
				},
				{
					sortable: false,
					Header: "New/Existing",
					id: "new_existing",
					/** @param {Tickets_Object} obj */
					accessor: obj => {//calculated based on if the client was new at the time of booking, ie first ticket for client
						return obj.new_existing ? "Existing" : "New";
					}
				},
				{
					sortable: false,
					Header: "Client",
					id: "ticket_customer",
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.customers ? (obj.customers.name) : '',
					Cell: props => {
						return (
							<span>
								<Link to={`/customers/${props.original.customers?.pkey}`}>
									{props.original.customers?.name}
								</Link>
							</span>
						);
					}
				},
				{
					sortable: false,
					Header: "City, State",
					id: "city_state",
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.customers ? (obj.customers_locations.city + ", " + obj.customers_locations.state) : ''
				},
				{
					sortable: false,
					Header: "Metro",
					id: "metro",
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.customers ? (obj.customers_locations.regions.name) : ''
				},
				{
					sortable: false,
					Header: "FreshDesk",
					id: "fresh_ticket",
					/** @param {Tickets_Object} obj */
					accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
					Cell: props => {
						return (
							<span>
								<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
							</span>
						);
					}
				}
			];

	return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Recently Booked', '')}
							{this.renderHeaderRight("Recently Booked", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: false,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
